import {ActionReducer, ActionReducerMap} from '@ngrx/store';
import {environment} from '../../environments/environment';
import * as fromRouterState from './utils';
import * as fromRouter from '@ngrx/router-store';

export interface State {
    router: fromRouter.RouterReducerState<fromRouterState.RouterStateUrl>;
}

export const reducers: ActionReducerMap<State> = {
    router: fromRouter.routerReducer
};

// console.log all actions
export function logger(reducer: ActionReducer<State>): ActionReducer<State> {
    return function (state: State, action: any): State {
        if(!action.type.includes('@ngrx')) {
            console.log(action.type + ' => PRIOR STATE = ', state);
            console.log(action.type + ' PAYLOAD ', action.payload);
        }
        return reducer(state, action);
    };
}

export const metaReducers: any[] = !environment.production
    ? [logger/*, storeFreeze*/]
    : [];
